module.exports = __webpack_public_path__ + "img/close_icon.2bf16be4.svg";